import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Button, ModalDialog } from 'ui-components';

import useStyles from './IkzeExtendedEntrepreneurDepositDialog.style';

const IkzeExtendedEntrepreneurDepositDialog: React.FC<{open: boolean, onClose: () => void}> = ({open, onClose}) => {
  const { t } = useTranslation('ike-or-ikze');
  const c = useStyles({});
  const content = [
    t('ikze.extended_entrepreneur_deposit_popup_content_1'),
    t('ikze.extended_entrepreneur_deposit_popup_content_2'),
    t('ikze.extended_entrepreneur_deposit_popup_content_3'),
  ];
  const additional = [
    t('ikze.extended_entrepreneur_deposit_popup_content_additional_1'),
    t('ikze.extended_entrepreneur_deposit_popup_content_additional_2'),
  ];
  const end = [
    t('ikze.extended_entrepreneur_deposit_popup_content_end_1'),
    t('ikze.extended_entrepreneur_deposit_popup_content_end_2'),
  ];

  return (
    <ModalDialog
      size="lg"
      open={open}
      onClose={onClose}
      title={t('ikze.extended_entrepreneur_deposit_popup_title')}
      content={<>
      <Typography fontWeight="bold" className={c.dialogSubtitle}>
          {t('ikze.extended_entrepreneur_deposit_popup_subtitle')}
        </Typography>
        <Typography variant="body1">
          <ol className={clsx(c.list, c.orderedList)}>
            {content.map((item, i) => (
              <li key={i} className={c.numberedListElement}>{item}</li>
            ))}
          </ol>
          <ul className={c.list}>
            {additional.map((item, i) => (
              <li key={i} className={c.letteredListElement}>{item}</li>
            ))}
          </ul>
          <ol className={clsx(c.list, c.orderedListSecondPart)}>
            {end.map((item, i) => (
              <li key={i} className={c.numberedListElement}>{item}</li>
            ))}
          </ol>
        </Typography>
      </>}
      primaryAction={<Button onClick={onClose}>{t('ikze.close')}</Button>}
    />
  );
};

export default IkzeExtendedEntrepreneurDepositDialog;
